import React from 'react';
import { useEffect, useState, useRef } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useAuth from '../hooks/useAuth';
import guttersJson from '../assets/gutters.json';
import {
    MDBCol,
    MDBRow,
    MDBCard,
    MDBCardImage,
    MDBCardBody,
    MDBCardText,
    MDBSwitch,
} from 'mdb-react-ui-kit';

const imgHref = (process.env.REACT_APP_ENV === "dev") ? 'https://testapi.bramac.cz/prilohy/cenovanabidka/gutter/' : '../prilohy/cenovanabidka/gutter/';

function Gutters(props) {
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();
    const didMount = useRef(false);
    const didLoad = useRef(false);

    const [gutterCalc, setGutterCalc] = useState(true);
    const [gutters, setGutters] = useState();
    const [chosenModel, setChosenModel] = useState("Stabicor M");
    const [chosenOkap, setChosenOkap] = useState();

    useEffect(() => {
        if (didLoad.current) return;
        let isMounted = true;
        const controller = new AbortController();

        const getOkapy = async () => {
            try {
                const response = await axiosPrivate.get('/okapy/get', {
                    signal: controller.signal
                }, { maxRedirects: 0 });
                didLoad.current = true;
                isMounted && setGutters(response.data);
                setChosenOkap(response.data.find(okap => okap.model === "Stabicor M" && okap.barva === "cerna"));
            } catch (err) {
                //setGutters(guttersJson);
                //setChosenOkap(guttersJson.find(okap => okap.model === "Stabicor M" && okap.barva === "cerna"));
            }
        }

        if (auth?.accessToken !== undefined) {
            getOkapy();
        } else {
            setGutters(guttersJson);
            setChosenOkap(guttersJson.find(okap => okap.model === "Stabicor M" && okap.barva === "cerna"));
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [auth]);

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            return;
        }
        if (!gutterCalc) {
            props.step.data = {
                chosenOkap: {
                    model: "Bez okapového systému",
                    barva: ""
                }
            }
        } else {
            props.step.data = { chosenOkap }
        }
    }, [chosenOkap, gutterCalc]);

    let guttersModels = [];
    gutters?.forEach(okap => {
        if (!guttersModels.some(o => o.model === okap.model)) {
            if (okap.model === "Bez okapového systému") { return; }
            guttersModels.push(okap);
        }
    })
    guttersModels.sort((a, b) => a.modelPoradi - b.modelPoradi);

    let guttersColors = [];
    gutters?.forEach(okap => {
        if (okap.model === chosenModel) {
            guttersColors.push(okap);
        }
    })
    guttersColors?.sort((a, b) => a.barvaPoradi - b.barvaPoradi);

    function showGutters() {
        return (gutterCalc) ? (
            <MDBRow className='mt-3'>
                <MDBCol md='12' lg='5' className='mb-4'>
                    {/*<h5 className='text-center mb-3'>Systém</h5>*/}
                    <div className="d-grid">
                        <MDBRow>
                            {guttersModels?.map(okap => {
                                const selectedMark = (chosenModel === okap.modelNazev) ? "" : "d-none"
                                return (
                                    <MDBCol size='6' lg='6' key={okap.typ + okap.model + okap.barva}>
                                        <MDBCard className='h-100' background='light' alignment='center'
                                            onClick={() => {
                                                setChosenModel(okap.model);
                                                setChosenOkap(okap);
                                            }}>
                                            <i className={"fas fa-check-circle selected-covering-icon " + selectedMark}></i>
                                            <MDBCardImage
                                                src={imgHref + okap.model + ".png"}
                                                alt='&empty;'
                                                position='top'
                                                className='p-1 pt-3'
                                            />
                                            <MDBCardBody className='p-1 mb-2'>
                                                <MDBCardText>{okap.modelNazev}</MDBCardText>
                                            </MDBCardBody>
                                        </MDBCard>
                                    </MDBCol>
                                )
                            })}
                        </MDBRow>
                    </div>
                </MDBCol>
                <MDBCol md='12' lg='6' offsetLg='1'>
                    {guttersColors?.length ? (
                        <MDBRow>
                            <h5 className='text-center mb-3'>Zvolte barvu</h5>
                            {guttersColors?.map(color => {
                                const selectedMark = (chosenOkap.barva === color.barva) ? "" : "d-none"
                                return (
                                    <MDBCol size='3' lg='3' key={color.modelNazev + color.barvaNazev}>
                                        <MDBCard className='h-100' background='light' alignment='center'
                                            onClick={() => { setChosenOkap(color); }}>
                                            <i className={"fas fa-check-circle selected-covering-icon " + selectedMark}></i>
                                            <MDBCardImage
                                                src={imgHref + "/okapy-vicko-" + color.barva + ".png"}
                                                alt='&empty;'
                                                position='top'
                                                className='p-1'
                                            />
                                            <MDBCardBody className='p-1 mb-2'>
                                                <MDBCardText>{color.barvaNazev}</MDBCardText>
                                            </MDBCardBody>
                                        </MDBCard>
                                    </MDBCol>
                                )
                            })}
                        </MDBRow>
                    ) : <div></div>}
                </MDBCol>
            </MDBRow>
        ) : (
            <div></div>
        )
    }

    return (
        <div>
            <MDBSwitch id='gutterCalculation' name='gutterCalculation'
                wrapperClass="d-flex align-items-center" defaultChecked={gutterCalc}
                label='Chci spočítat okapový systém' labelClass='fs-5'
                onClick={(e) => { setGutterCalc(!gutterCalc) }} />

            {showGutters()}
        </div>
    );

}

export default Gutters;